module.exports = __webpack_public_path__ + "23102f097860ae68b653fa7029352109.png";